// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609240432/js/" + chunkId + "." + {"44":"adf7ff5a","225":"06a10c72","481":"801c0843","486":"75551242","770":"f6aef067"}[chunkId] + ".0.8419392256105969.chunk.js";
};